import { render, staticRenderFns } from "./tt-editor.vue?vue&type=template&id=61883872&scoped=true&"
import script from "./tt-editor.vue?vue&type=script&lang=js&"
export * from "./tt-editor.vue?vue&type=script&lang=js&"
import style0 from "./tt-editor.vue?vue&type=style&index=0&id=61883872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61883872",
  null
  
)

export default component.exports